import { useState } from "react"
import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { OptOutNewScheduleItem } from "./opt-out-new-schedule-item"

export function OptOutNewScheduleAmendsDialog({ newSchedules = [] }) {
    const [selections, setSelections] = useState(() => buildInitialSelections(newSchedules))

    return (
        <DialogBox
            title={<Typography variant="h5">Record author notes on new schedules?</Typography>}
            value={selections}
            data-cy="opt-out-new-schedule-amends-dialog"
            okCaption="Continue"
        >
            <Box>
                <Typography>Do you want author notes added to the following new schedules?</Typography>
                <Typography>Untick any schedule you don't want the note recorded on.</Typography>
                <Box mt={2} data-cy="opt-out-new-schedule-list">
                    <PagedRepeat
                        pageSizeName="opt-out-new-schedules"
                        list={newSchedules}
                        item={<OptOutNewScheduleItem selections={selections} onToggle={handleToggle} />}
                        showTop
                    />
                </Box>
            </Box>
        </DialogBox>
    )

    function handleToggle(id) {
        setSelections((current) => ({ ...current, [id]: !current[id] }))
    }
}

function buildInitialSelections(newSchedules = []) {
    const output = {}
    for (const { id, recordAmends } of newSchedules) {
        output[id] = recordAmends !== false
    }
    return output
}
